<template>
    <v-container fluid>
        <v-btn
            :loading="billings === null"
            @click="newBilling"
            bottom
            class="mb-10"
            color="secondary darken-1"
            fab
            fixed
            right
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-row
            align="center"
            no-gutters
        >
            <v-col
                cols="12"
                justify="center"
                lg="4"
                sm="6"
            >
                <v-subheader>
                    <h2>Billings ({{ totalMatches }})</h2>
                </v-subheader>
            </v-col>
            <v-col
                cols="12"
                lg="4"
                sm="6"
            >
                <v-text-field
                    @click:clear="setSearch('')"
                    @input="setSearch"
                    clearable
                    label="Search"
                    prepend-icon="mdi-magnify"
                    single-line
                />
            </v-col>
            <v-col
                class="text-right"
                cols="12"
                lg="4"
                sm="6"
            >
            </v-col>
        </v-row>
        <v-container class="pb-10">
            <v-row
                justify="center"
                v-if="billings === null"
            >
                <v-col
                    :key="i"
                    cols="12"
                    v-for="i in 6"
                >
                    <v-skeleton-loader
                        elevation="4"
                        type="card"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row
                justify="center"
                v-else
            >
                <v-col
                    :key="billing.id"
                    cols="12"
                    v-for="billing in billings"
                >
                    <v-card
                        class="billing-card fill-height"
                        elevation="4"
                        style="overflow: hidden"
                    >
                        <v-card-title
                            @click="loadBillingForm(billing.id)"
                            style="cursor: pointer"
                        >
                            <h5>Billing #{{ billing.id }}</h5>
                        </v-card-title>
                        <v-card-subtitle
                            @click="loadBillingForm(billing.id)"
                            style="cursor: pointer"
                        >
                        Patient full name: {{billing.patient.identity.name}} {{billing.patient.identity.surname}}
                        <br>
                        Patient ID: {{billing.patient.identity.identificationNumber}}
                        <br>
                        Invoice numbers: {{billing.billingItems.map(x => x.invoiceNumber).join(", ")}}
                        <br>
                        Last invoice date: {{billing.billingItems.reduce((a,b) => a > b.createdAt ? a : b.createdAt, '')}}
                        <br>
                        Final invoice loaded: {{billing.convertToAccount ? "Yes" : "No"}}  
                        <br>
                        Service Provider: {{getProviderName(billing.providerId)}}
                        <br>
                        In Account: {{billing.accountId > 0 ? billing.accountId : 'No'}}                      
                        </v-card-subtitle>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            v-model="billingFormVisible"
        >
            <v-sheet
                class="base-background"
                min-height="100%"
            >
                <v-toolbar
                    color="secondary darken-1"
                    dark
                >
                    <v-btn
                        @click="closeBillingForm"
                        dark
                        icon
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Billing Details</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-container>
                    <v-row
                        align="center"
                        justify="center"
                        v-if="true"
                    >
                        <BillingForm
                            :billing-id="billingFormBillingId"
                            :key="billingFormKey"
                            :providers="providers"
                            @close="closeBillingForm"
                            @deleted="deleteBilling"
                            @saved="updateBilling"
                        />
                    </v-row>
                </v-container>
            </v-sheet>
        </v-dialog>
        <v-pagination
            :length="pagesCount"
            @input="paginationDebounce(500, true)"
            class="pagination-bar base-background"
            total-visible="7"
            v-model="pageNo"
            v-show="pagesCount > 1"
        ></v-pagination>
    </v-container>
</template>

<script>
import uuid4 from "../helpers/uuid4";
import BillingForm from "../components/forms/BillingForm";

export default {
    name: "Billings",
    props: [
                "notFinal",
                "final",
                "submitted",
                "showNewForm",
                "lastInvoiceAgedDaysMin",
                "lastInvoiceAgedDaysMax",
                "billingId"
            ],
    data: function() {
        return {
            //main data
            billings: null,
            billingStatus: null,
            providers: null,
            //pagination
            pageNo: 1,
            pageSize: 6,
            pagesCount: 0,
            totalMatches: null,
            searchString: "",
            orderBy: "",
            sortOrder: null,
            paginationTimeout: null,
            requestId: uuid4(),

            //form data
            billingFormVisible: false,
            billingFormKey: 0,
            billingFormBillingId: 0, //new Billing(),
        };
    },
    mounted: function() {
        this.getBillings();
        this.getProviders();
        if(this.showNewForm)
            this.newBilling();
    },
    components: {
        BillingForm
        //
    },
    methods: {
        getProviderName(id) {
            var i = this.providers
                ? this.providers.find(x => x.key == id)
                : null;
            return i ? i.value : "";
        },
        getProviders() {
            this.$store.dispatch("providers/getlist").then(response => {
                this.providers = response;
            });
        },
        getBillings() {
            var requestId = (this.requestId = uuid4());
            this.$store
                .dispatch("billings/get", {
                    urlParameters: {
                        pageNo: this.pageNo,
                        pageSize: this.pageSize,
                        searchString: this.searchString,
                        orderBy: this.orderBy,
                        sortOrder: this.sortOrder,
                        notFinal: !!this.notFinal,
                        final: !!this.final,
                        submitted: !!this.submitted,
                        lastInvoiceAgedDaysMin:
                            this.lastInvoiceAgedDaysMin > -1
                                ? this.lastInvoiceAgedDaysMin
                                : null,
                        lastInvoiceAgedDaysMax:
                            this.lastInvoiceAgedDaysMax > -1
                                ? this.lastInvoiceAgedDaysMax
                                : null
                    },
                    id: this.billingId > -1
                                ? this.billingId
                                : null,
                    requestId: requestId
                })
                .then(billingsResponse => {
                    if (this.requestId == billingsResponse.requestId) {
                        this.billings = billingsResponse.data.page;
                        this.totalMatches = billingsResponse.data.total;
                        this.pageSize = billingsResponse.data.pageSize;
                        this.pageNo = billingsResponse.data.pageNumber;
                        this.pagesCount = Math.ceil(
                            billingsResponse.data.total / this.pageSize
                        );
                    }
                    if (this.pageNo > this.pagesCount)
                        this.pageNo = this.pagesCount;
                });
        },
        paginationDebounce(debounceTime, isPaging) {
            if (!isPaging) {
                this.pageNo = 1;
                this.pagesCount = 0;
            }
            if (this.billings !== null) this.billings = null;
            clearTimeout(this.paginationTimeout);
            this.paginationTimeout = setTimeout(
                this.getBillings,
                debounceTime
            );
        },
        setSearch(value) {
            this.searchString = value;
            this.paginationDebounce(1000);
        },
        //FORM METHODS---------------------------------
        newBilling() {
            this.loadBillingForm(0);
        },
        loadBillingForm(billingId) {
            this.billingFormBillingId = billingId;
            this.billingFormKey = billingId;
            this.billingFormVisible = true;
        },
        closeBillingForm() {
            this.billingFormVisible = false;
            this.billingFormKey = null;
        },
        updateBilling() {
            this.paginationDebounce(0, true);
        },
        deleteBilling() {
            this.paginationDebounce(0, true);
        },
        deletePatient() {
            this.paginationDebounce(0, true);
        }
    }
};
</script>

<style lang="stylus" scoped>
.billing-card {
    /* background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1)) */
    .center-content {
        background-color: rgba(127, 127, 127, 0.15);
    }
}

.theme--dark {
    .patient-panel {
        .v-card {
            background-color: rgba(127, 127, 127, 0.1);
        }
    }
}

.pagination-bar {
    // position: fixed;
    bottom: 0;
    margin: auto;
    left: 0;
    right: 0;
    padding-bottom: 0.1rem;
    padding-top: 0.1rem;
    /*
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border:1px solid rgba(127, 127, 127, 0.2)
    */
}

.theme--light {
    .base-background {
        background: #FFFFFF;
    }
}

.theme--dark {
    .base-background {
        background: #121212;
    }
}
</style>
